<div class="container" style="padding-top: 110px;">
  <br>
  <div style="padding-left: 15px;">
  <app-breadcrumb  category="Shopping Bag"></app-breadcrumb>

  </div>
  <div class="col-lg-9">
    <div class="cart">
      <b class="t-1">Products in Bag</b>
    </div>
  </div>
  <br>
 <div class="container">
  <div class="row">
    <div class="col-lg-9">
      <app-checkout-item *ngFor="let item of items" [data]="item"   ></app-checkout-item>
    </div>

    <div class="col-lg-3" >
      <div class="bar"   style="border-left:solid 1px #00000029;margin-right: 20px;padding-left: 30px;" >
        <h2 style="font-weight: bold; font-family: 'proxima-nova';">Order summary</h2> <br>
      <small class="text-muted float-left">Subtotal: {{sub_total | currency:'INR'}}</small> 
      <br>
      <small class="text-muted float-left">Shipping: {{deliver_fee | currency:'INR'}}</small>
      <br>
      <small class="text-muted float-left">Discount: {{discount | currency:'INR'}}</small> 
      <br>

      <b class="float-left">Total: {{total | currency:'INR'}}</b>
      <br>
      <br>
      <button (click)="deploy()" class="btn btn-block button text-center"><a class="navi rou"
          style="color: white;background-color: green; text-decoration: none;" routerLink="/address">Checkout to
          payment</a></button>
      </div>
    
     <div class="bar" style="padding:20px;">
      <div class="checkout-content">
        <i class='bx bxs-lock-alt float-left' style="margin-top: 2px;"></i>Consumes data protection <br>
        <i class='bx bx-check-shield float-left' style="margin-top: 3px;"></i>Secure payment with SSL <br>
      </div> <br>
      <h6>delivery information</h6> <br>
      <small class="text-muted float-left">Delivery Time:</small> <small class="text-muted float-right">3 to 8 working
        days</small><br>
      <small class="text-muted float-left">Delivery by:</small> <small
        class="text-muted float-right">Shippocket</small><br>

     </div>
    </div>
  </div>
 </div>
<br>
 <div class="container">
  <div class="bottom-btn">
    <div class="row">
      <div class="col-lg-2">
        <button routerLink="/wishlist" class="btn btn-block button1" style=" border: 2px solid;">Bag of Wishlist</button>
      </div> <br> &nbsp;
      <div class="col-lg-3">
        <button routerLink=".." class="btn btn-block button2">Continue Shopping</button>
      </div><br> &nbsp;
      <div class="col-lg-4">
        <div class="input-group mb-3">
          <input style="text-transform:uppercase; border: 2px solid;"  #cop type="text" class="form-control" placeholder="Enter coupon / Promo code" aria-label="Enter coupon / Promo code" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="btn button2" type="button"  (click)="couponie(cop.value)" >&nbsp;&nbsp; Apply &nbsp;&nbsp;</button>
          </div>
        </div>
        <h6 style="font-size: 13px; font-family: 'proxima-nova'; color: gray; display: {{expired || invalid ? 'block': 'none'}}">{{expired? 'Code Expired': invalid && cop.value? 'Invalid Code': ''}}</h6>
        <h6 style="font-size: 13px; font-family: 'proxima-nova'; color: green; display: {{coupon ? 'block': 'none'}}">Code Applied with {{coupon?.offer}}% Discount</h6>
      </div>
    </div>
   </div>
 </div>
<br><br><br>
</div>
<br>
